/*
 * @Description:
 * @Author: Victor
 * @Date: 2023-03-29 20:04:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024/12/10 10:31:14
 */
const zh = require('./langBattery/zh-CN/translation.json');
const en = require('./langBattery/en-US/translation.json');
const de = require('./langBattery/de-DE/translation.json');
const ja = require('./langBattery/ja-JP/translation.json');
const it = require('./langBattery/it-IT/translation.json');
const nl = require('./langBattery/nl-NL/translation.json');
const sp = require('./langBattery/sp-SP/translation.json');
const el = require('./langBattery/el-GR/translation.json');
const fr = require('./langBattery/fr-FR/translation.json');
export const batteryExpansionDataLang = { zh, en, de, ja, it, nl, sp, el, fr };
